import axios from "axios";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";

export default function ChallengeInviteCard({ challenge, onJoin }) {
  const baseUrl = import.meta.env.VITE_APP_BASE_URL;
  const [userHandler, setUserHandler] = useState("");
  const [isJoining, setIsJoining] = useState(false);

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const response = await axios.get(
          `${baseUrl}/v2/user/${challenge.creator}/handleByUserId`,
        );
        const handle = response.data.handle || challenge.creator;
        setUserHandler(
          handle && handle.length > 1
            ? handle.charAt(0).toUpperCase() + handle.slice(1).toLowerCase()
            : handle.toUpperCase(),
        );
      } catch (error) {
        console.error("Failed to fetch user details:", error);
        setUserHandler(challenge.creator);
      }
    };

    if (challenge.creator) {
      fetchUserDetails();
    }
  }, [challenge.creator, baseUrl]);

  const handleJoin = async () => {
    if (isJoining) return; // Prevent double-clicking

    setIsJoining(true);
    try {
      console.log(`Updating challenge status for ID: ${challenge._id}`);

      // Update challenge status to 'ready'
      const response = await axios.put(
        `${baseUrl}/play/challenges/${challenge._id}/status`,
        {
          status: "ready",
        },
      );

      console.log("Challenge status updated successfully:", response.data);
      toast.success("Successfully joined the challenge!");

      // Proceed with join logic
      onJoin(challenge._id);
    } catch (error) {
      console.error("Failed to update challenge status:", error);

      let errorMessage = "Failed to join challenge. Please try again.";

      if (error.response?.data?.detail) {
        errorMessage = error.response.data.detail;
      } else if (error.response?.status === 404) {
        errorMessage = "Challenge not found or no longer available.";
      } else if (error.response?.status === 400) {
        errorMessage = "Invalid challenge request.";
      } else if (error.response?.status >= 500) {
        errorMessage = "Server error. Please try again later.";
      }

      toast.error(errorMessage);
    } finally {
      setIsJoining(false);
    }
  };

  return (
    <div className="bg-white flex justify-evenly shadow-md rounded-2xl p-4 border border-gray-200 hover:shadow-lg transition-all duration-200 w-full mx-auto">
      <p className="text-lg font-semibold text-gray-800 mb-2">
        <span className="text-blue-600">{userHandler}</span> has challenged you!
      </p>
      <button
        onClick={handleJoin}
        disabled={isJoining}
        className={`px-4 py-2 rounded-lg transition duration-200 font-semibold ${
          isJoining
            ? "bg-gray-400 text-gray-200 cursor-not-allowed"
            : "bg-blue-600 text-white hover:bg-blue-700"
        }`}
      >
        {isJoining ? "Joining..." : "Join Challenge"}
      </button>
    </div>
  );
}
